import Axios from 'axios'

// constant
import * as types from '../types'
import { host } from '../../../../host'

// helper
import catchErrorApi from '../../../../helper/catchErrorApi'
import autoDownloadFromBlob from '../../../../helper/autoDownloadFromBlob'

// action
import { addLoading, removeLoading } from '../../../commonAction'

const apiGetFaceRegconitionReport = `${host}admin/exportJSON/faceRegconitionReport`

export const getFaceRegconitionReport = ({
    FromDate,
    ToDate,
    BranchIDs,
    ReportCodeName,
    BranchName,
}) => async (dispatch) => {
    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(apiGetFaceRegconitionReport, dataRequest)
        const { data } = res
        dispatch({
            type: types.GET_FACE_REGCONITION_REPORT,
            payload: {
                condFilter: {
                    FromDate,
                    ToDate,
                    BranchIDs,
                    ReportCodeName,
                    BranchName,
                },
                listData: data.Data || [],
            },
        })
        dispatch(removeLoading())
    } catch (err) {
        dispatch(removeLoading())
        catchErrorApi(
            err,
            dispatch,
            types.GET_FACE_REGCONITION_REPORT_ERROR,
            () => false
        )
    }
}

export const exportFaceRegconitionReport = ({
    FromDate,
    ToDate,
    BranchIDs,
    ReportCodeName,
    BranchName,
    BranchCodes,
}) => async (dispatch) => {
    if (!BranchCodes) return

    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ExportExcel: true,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(apiGetFaceRegconitionReport, dataRequest, {
            responseType: 'blob',
        })
        dispatch(removeLoading())
        const { data } = res
        if (BranchCodes.length === 1) {
            autoDownloadFromBlob(data, `${ReportCodeName}-${BranchCodes[0]}`)
        } else {
            autoDownloadFromBlob(
                data,
                `${ReportCodeName}-${BranchCodes.join('-')}`
            )
        }
    } catch (err) {
        dispatch(removeLoading())
        console.log(err)
    }
}
